export const messageConstants={
  sevirity:{
    success:'success',
    error:'error',
    warn: 'warn',
    info: 'info'
  },
  errorMessages:{
    forgotPassword:'Email Address doesn\'t exists',
    login: 'Username or Password incorrect'
  },
  successMessages:{
    forgotPassword:'Please check your mailbox to reset the password'
  }
  ,activeCompany:{
    success:'Successfully'
  },
  deleteCompany:{
    success:'Deleted Successfully'
  },
  activeUser:{
    success:' Successfully'
  },
  deleteSector:{
    success:'Deleted Successfully'
  },
  deleteExchange:{
    success:'Deleted Successfully'
  },
  bulkUpload:{
    success:'File Uploaded Successfully',
    deletedSuccess:'Deleted Successfully',
    failedTitle:'_failed.csv',
    updatedTitle:'_updated.csv',
    sampleTemplate:'sample_template.csv',
    duplicateTitle:'_duplicate.csv',
    deleteDialogTitle:'Delete File Log',
    deleteDialogMessage:'Are you sure you want to delete this file upload log?',
    fileAcceptFormat:'.xlsx,.csv,.xls',
    ok:'OK',
    cancel:'Cancel',
    successTitle:'Success',
    errorTitle:'Error',
    failed:'File upload failed',
    fileUploadSizeMessage:'The file size can not exceed 5MB.'
  }
}
